// ID-12905 spike — throwaway, delete after verification.
// Proves a shared component can (a) link to host-app pages, (b) own its own sub-pages, both through
// the host app's <Router> and without hardcoding a single host path:
//  - `hostPaths`: the host app's destinations the component needs (its route table differs per app).
//    Passing paths rather than "navigate" callbacks lets shared render real <Link>s (href,
//    middle-click, right-click) — a callback that returns a path would work the same way.
//  - `basePath`: where the host mounted this component; the sub-route table under it is shared's own
//    (each sub-page's path lives in its *.route.ts, e.g. SpikeSubPage.route.ts).
import { Link, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import * as spikeSubPageRoute from './SpikeSubPage.route';

type SpikeNavDemoProps = {
  /** Where the host app mounted this component — sub-pages hang off it */
  basePath: string;
  /** Host-app destinations this component links to — the app decides the actual paths */
  hostPaths: {
    settings: string;
  };
};

export default function SpikeNavDemo({ basePath, hostPaths }: SpikeNavDemoProps) {
  const history = useHistory();
  const location = useLocation();
  const subPagePath = spikeSubPageRoute.getPath({ basePath });

  return (
    <div data-testid="spike-nav">
      <div data-testid="spike-nav-location">current: {location.pathname}</div>

      <Switch>
        <Route exact path={subPagePath}>
          <div data-testid="spike-nav-subpage">
            Sub-page owned by the shared component. <Link to={basePath}>Back to spike index</Link>
          </div>
        </Route>

        <Route exact path={basePath}>
          <ul>
            <li>
              <Link to={hostPaths.settings}>Go to host Settings (Link, host path via props)</Link>
            </li>

            <li>
              <Link to={subPagePath}>Open shared sub-page (Link, basePath-relative)</Link>
            </li>

            <li>
              <button type="button" onClick={() => history.push(subPagePath)}>
                Open shared sub-page (history.push after an action)
              </button>
            </li>
          </ul>
        </Route>
      </Switch>
    </div>
  );
}
